import styled, { css } from "styled-components";

export const Container = styled.div``;

export const Top = styled.div`
  ${({ theme }) => css`
    margin-bottom: 30px;

    display: flex;
    align-items: center;

    p {
      font-size: ${theme.font.sizes.large};
      color: ${theme.colors.title};
      font-weight: ${theme.font.bold};
    }
  `}
`;

export const ButtonClose = styled.button`
  ${({ theme }) => css`
    width: 35px;
    height: 35px;
    background-color: ${theme.colors.background_light};
    border-radius: 10px;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 25px;
  `}
`;

export const Content = styled.main`
  ${({ theme }) => css`
    p {
      font-size: ${theme.font.sizes.small};
      color: ${theme.colors.text};
      line-height: ${theme.font.sizes.xxlarge};
      white-space: pre-wrap;
    }
  `}
`;
